'use client'

import { useSearchParams, useRouter, usePathname } from 'next/navigation'
import { useState } from 'react'

export default function DateSwitch() {
    const router = useRouter()

    const pathname = usePathname()
    const searchParams = useSearchParams()
    const params = new URLSearchParams(searchParams.toString())

    const [day, setDay] = useState(Number(params.get('day')) ?? 1)

    function changeDay(input: number) {
        setDay(input)
        params.set('day', input.toString())
        params.set('page', '1')
        router.replace(`${pathname}?${params}`)
    }

    return (
        <div className="flex h-12 w-full justify-items-center">
            <button
                className={`h-full w-full content-center justify-items-center border border-black border-l-transparent border-r-transparent border-t-transparent ${day === 1 ? `border-b-3 border-b-[#F9BB1D] font-bold` : ``}`}
                onClick={() => changeDay(1)}
            >
                <p>Sabato 7</p>
            </button>
            <button
                className={`h-full w-full content-center justify-items-center border border-black border-l-transparent border-r-transparent border-t-transparent ${day === 2 ? `border-b-3 border-b-[#F9BB1D] font-bold` : ``}`}
                onClick={() => changeDay(2)}
            >
                <p>Domenica 8</p>
            </button>
        </div>
    )
}
